import type { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import type { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import type { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import type { DiscountStore } from '@gamiphy/loyalty-station-desktop/store/reward/discount';

export class StoreSdk {
  public async getAppStore(): Promise<typeof AppStore> {
    const { AppStore: store } = await import('@gamiphy/loyalty-station-desktop/store/app');

    return store;
  }

  public async getThemeStore(): Promise<typeof ThemeStore> {
    const { ThemeStore: store } = await import('@gamiphy/loyalty-station-desktop/store/theme');

    return store;
  }

  public async getUserStore(): Promise<typeof UserStore> {
    const { UserStore: store } = await import('@gamiphy/loyalty-station-desktop/store/user');

    return store;
  }

  public async getDiscountStore(): Promise<typeof DiscountStore> {
    const { DiscountStore: store } = await import('@gamiphy/loyalty-station-desktop/store/reward/discount');

    return store;
  }
}
